
const state = {
  id: null,
  default_user_id: undefined,
  enabled: false,
  owner_id: undefined,
  owner_type: '',
  title: '',
  token: '',
}

export const requiredFields = [
  { key: 'default_user_id' },
]

export default state
